<script setup lang="ts"></script>

<template>
	<div class="page">
		<router-view></router-view>
	</div>
</template>

<style lang="scss">
.page {
	width: 100vw;
	min-height: 100vh;
	background: #f3f7fd;
	overflow-x: hidden;
}
div {
	box-sizing: border-box;
}
/* 移除 input 框选中时的边框 */
input:focus {
	outline: none;
}
@media screen and (min-width: 768px) {
	.scale {
		& > img {
			transform: scale(1);
			transition: all 0.5s;
		}

		& > img:hover {
			transform: scale(1.2);
			transition: all 0.5s;
		}
	}

	.title_color {
		&:hover {
			color: #e3771f !important;
		}
	}
}
</style>
